<template>
  <div class="customer-logo-slider">
    <div class="slider-container">
      <div class="slider-track" :style="{ animationDuration: duration + 's' }">
        <img src="../assets/img/casePage/customers.png" alt="客户Logo" class="slider-image" />
        <img src="../assets/img/casePage/customers.png" alt="客户Logo" class="slider-image slider-image-second" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerLogoSlider",
  props: {
    speed: {
      type: Number,
      default: 0 // 数值越大越快
    }
  },
  computed: {
    duration() {
      // 根据速度计算动画持续时间
      return 30 - Math.min(this.speed, 50) / 2;
    }
  }
};
</script>

<style scoped>
.customer-logo-slider {
  overflow: hidden;
  width: 100%;
  padding: 40px 0;
  /* background: #ffffff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  border-radius: 8px; */
  margin: 20px 0;
  position: relative;
}

.slider-container {
  overflow: hidden;
  width: 100%;
}

.slider-track {
  display: flex;
  width: 400%;
  animation: scroll var(--duration, 60s) linear infinite;
}

.slider-image {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.slider-image-second {
  margin-left: -60px;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CustomerLogoSlider.vue